import { selectedKeys } from "@/contexts/global";
import axiosRequest from "@/utils/axios-utils";

const GetProductsByCategoryIdData = async (params) => {
  const {
    token,
    categoryID,
    amountOfData,
    pageNo = 0,
    region_id,
    currentSortFilterKeys = "sortBy=position&sortDir=ASC",
  } = params;
  const regionId = region_id && region_id != 'NaN' && region_id != 'undefined' ? region_id : '1101'
  let url = `/facets/categoryV2/${categoryID}?pageSize=${amountOfData}&pageNo=${pageNo}&${currentSortFilterKeys}&${selectedKeys}&regionId=${regionId}&select=${regionId}`;
  console.log("url in getProductsData", url);
  const req = await axiosRequest({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return req;
};

export default GetProductsByCategoryIdData;
